import React, {useEffect, useState} from 'react'
import './home.css'
import {Button, FormControlLabel, Radio, RadioGroup, styled, TextField} from "@mui/material";
import useAxiosInstance from "../useAxiosInstance";
import FormData from "form-data";
import Swal from "sweetalert2";
import Spinner from "react-spinners/BeatLoader";
import {useNavigate} from "react-router-dom";
import {RiAttachmentLine} from "react-icons/ri";
import {IoLogOut} from "react-icons/io5";
import formImage from "../assets/formImage.jpg";
import {CiTrash} from "react-icons/ci";

const regex = /^\d+\.\d+\.\d+$/;

function Home() {
    const instance = useAxiosInstance();
    const navigate = useNavigate();

    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true
    });
    const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            confirmButton: "btn btn-success", cancelButton: "btn btn-danger"
        }, buttonsStyling: true
    });

    const [data, setData] = useState({file: "", type: 1, version: ""});
    const [response, setResponse] = useState([]);
    const [latestVersion, setLatestVersion] = useState({});
    const [IsSpinner, setIsSpinner] = useState(false);

    const inputFileHandler = (event) => {
        const {name} = event.target;
        setData({
            ...data,
            [name]: event.target.files[0]
        });
    };

    const getHistory = () => {

        instance.get(`FotaFiles/GetHistory?token=${localStorage.getItem('_MIHEALTHTOKEN')}`)
            .then((response) => {
                setIsSpinner(false);
                setResponse(response);
            })
            .catch(() => {
                setIsSpinner(false);
            });
    };
    const getLatestVersion = () => {

        instance.get(`FotaFiles/GetLatestVersion?token=${localStorage.getItem('_MIHEALTHTOKEN')}`)
            .then((response) => {
                setIsSpinner(false);
                setLatestVersion(response);
            })
            .catch(() => {
                setIsSpinner(false);
            });
    };

    const deleteFile = (id) => {
        swalWithBootstrapButtons.fire({
            html: '<div class="d-flex gap-2 pt-1">' +
                '<div class="swalIcon">' +
                '<i class="fa-solid fa-2x fa-trash-can text-danger"></i>' +
                '</div>' +
                '<div class="mb-4"> ' +
                '<div class="swalHead">Delete!</div>' +
                `<div class="fs-5 text-start">Are you sure you want to delete? This action cannot be reverted.</div>` +
                '</div>' +
                '</div>',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            cancelButtonText: "Cancel!"
        }).then((result) => {
            if (result.isConfirmed) {
                setIsSpinner(true);
                instance.get(`FotaFiles/DeleteFile?id=${id}&token=${localStorage.getItem('_MIHEALTHTOKEN')}`).then((response) => {
                    Toast.fire({
                        icon: "success",
                        title: "Deleted Successfully"
                    });
                    getHistory();
                    getLatestVersion();
                })
                    .catch(() => {
                    }).finally(() => {
                    setIsSpinner(false);
                });
            }
        }).catch(() => {
        })
    }

    const uploadFotaFile = (data) => {
        instance.post('FotaFiles/UploadFotaFile', data, {
            headers: {'Content-Type': 'multipart/form-data'}
        })
            .then((response) => {
                Toast.fire({
                    icon: "success",
                    title: "Uploaded Successfully"
                });
                setData({
                    file: "", type: 1, version: ""
                })
                getHistory();
                getLatestVersion();
            })
            .catch(() => {
            }).finally(() => {
            setIsSpinner(false);
        });
    };

    useEffect(() => {
        setIsSpinner(true);
        getHistory();
        getLatestVersion();
    }, []);

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)', height: 1,
        whiteSpace: 'nowrap', width: 1
    });

    const submitHandler = (e) => {
        e.preventDefault();

        if (!data.file || !data.type || !data.version) {
            Swal.fire("Please Fill all the Fields.");
            return false;
        }
        if (!regex.test(data.version)) {
            Swal.fire("Please follow the correct version format, such as 1.0.0.");
            return false;
        }

        const formData = new FormData();
        formData.append('File', data.file);
        formData.append('Type', data.type);
        formData.append('Version', data.version);
        formData.append('token', localStorage.getItem('_MIHEALTHTOKEN'));

        uploadFotaFile(formData);
        setIsSpinner(true);
    }

    return (
        <div className="innerMainContainer">
            <div className="mt-3 d-flex align-items-center justify-content-between mx-3 mb-3">
                <h3 className="mb-0" style={{letterSpacing: 1}}>MI Health File Uploader.</h3>
                <Spinner color='#00c292' loading={IsSpinner}/>
                <Button onClick={() => {
                    localStorage.clear();
                    navigate("/");
                }} variant="outlined">
                    <IoLogOut size={26}/>
                </Button>
            </div>
            <div className="inputForm mb-3">
                <div className="imageContainer">
                    <img src={formImage} alt="form"/>
                </div>
                <form className="form" onSubmit={submitHandler}>
                    <h1 className="text-center mb-3" style={{letterSpacing: 1}}>Attach your file here.</h1>
                    <TextField
                        sx={{width: "100%", marginBottom: "1rem"}} size="small"
                        label="Version" error={!!(!regex.test(data.version) && data.version)}
                        name="version"
                        helperText={!regex.test(data.version) && data.version ? "Please follow the correct version format, such as 1.0.0" : ""}
                        value={data.version} placeholder="1.0.0"
                        onChange={(e) => setData(prevState => ({
                            ...prevState, version: e.target.value
                        }))}/>
                    <Button component="label" variant="outlined" className="w-100 justify-content-start mb-2"
                            style={{padding: "10px"}}>
                        <RiAttachmentLine/>
                        <VisuallyHiddenInput onChange={inputFileHandler} name="file" type="file" accept=".zip"/>
                        <small style={{fontWeight: 380}} className="ms-2">{data.file.name}</small>
                    </Button>
                    <RadioGroup className="mb-1 ms-1"
                                value={data.type}
                                onChange={(event) => setData(prev => ({
                                    ...prev,
                                    type: parseInt(event.target.value, 10)
                                }))} row>
                        <FormControlLabel
                            sx={{"& .MuiFormControlLabel-label": {fontSize: 14}}}
                            value={1} checked={data.type === 1}
                            control={<Radio/>}
                            label="Main Controller"/>
                        <FormControlLabel
                            sx={{"& .MuiFormControlLabel-label": {fontSize: 14}}}
                            value={2} checked={data.type === 2}
                            control={<Radio/>}
                            label="Sub Controller"/>
                    </RadioGroup>
                    <Button className="w-100" variant="contained" type="submit">Submit</Button>
                    <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap mt-3">
                        <div className="d-flex justify-content-between align-items-center w-100">
                            Main Controller latest version <span
                            className={latestVersion.andriodLatestVersion ? "border-bottom border-black" : ""}>{latestVersion.andriodLatestVersion ? latestVersion.andriodLatestVersion : "--.--.--"}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100">
                            Sub Controller latest version <span
                            className={latestVersion.annabLatestVersion ? "border-bottom border-black" : ""}>{latestVersion.annabLatestVersion ? latestVersion.annabLatestVersion : "--.--.--"} </span>
                        </div>
                    </div>
                </form>
            </div>
            <div className="table-container">
                <table>
                    <thead>
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Link</th>
                        <th>Version</th>
                        <th>Type</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {response.map(r => (
                        <tr key={r.id}>
                            <td>{r.id}</td>
                            <td>{r.name}</td>
                            <td>
                                <a rel="noreferrer" target="_blank"
                                   href={r.link}>{r.link}
                                </a>
                            </td>
                            <td>{r.version}</td>
                            <td>{r.type}</td>
                            <td>
                                <CiTrash size={22} cursor='pointer' onClick={() => {
                                    deleteFile(r.id);
                                }}/>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Home
